import 'npm:jquery-validation/dist/jquery.validate.js';
import { getLocaleSettings } from '../services/settings';

( async function() {
	try {
		const { jQuery: { validation: { language } } } = await getLocaleSettings();
		if( language !== 'en' ) {
			await SystemJS.import( `npm:jquery-validation/dist/localization/messages_${encodeURIComponent(language)}.js` );
		}
	} catch( ex ) {}
}() );
